export const formFieldNamesData = {
    account: "account",
    accounts: "accounts",
    action: "action",
    allowedDaySlip: "allowedDaySlip",
    allowedDaySlipFrom: "allowedDaySlipFrom",
    allowedDaySlipTo: "allowedDaySlipTo",
    amount: "amount",
    amountFrom: "amountFrom",
    amountTo: "amountTo",
    apiKey: "apiKey",
    apiSecret: "apiSecret",
    balanceType: "balanceType",
    businessType: "businessType",
    category: "category",
    city: "city",
    companyEmail: "companyEmail",
    companyName: "companyName",
    companyStructure: "companyStructure",
    companyWebsite: "companyWebsite",
    condition: "condition",
    confidence: "confidence",
    confidenceFrom: "confidenceFrom",
    confidenceTo: "confidenceTo",
    confirmPassword: "confirmPassword",
    connectionType: "connectionType",
    country: "country",
    credit: "credit",
    creditColumn: "creditColumn",
    creditValues: "creditValues",
    currency: "currency",
    dataAction: "dataAction",
    dataFormat: "dataFormat",
    dataSource: "dataSource",
    dataSourceA: "dataSourceA",
    dataSourceB: "dataSourceB",
    dataSources: "dataSources",
    dataType: "dataType",
    date: "date",
    dateField: "dateField",
    dateFormat: "dateFormat",
    dateRange: "dateRange",
    debit: "debit",
    debitColumn: "debitColumn",
    debitValues: "debitValues",
    defaultValue: "defaultValue",
    description: "description",
    email: "email",
    employees: "employees",
    entries: "entries",
    entry: "entry",
    exceptionConScoreThreshold: "exceptionConScoreThreshold",
    firstAmountType: "firstAmountType",
    firstName: "firstName",
    frequency: "frequency",
    fullName: "fullName",
    hasTimeComponent: "hasTimeComponent",
    hierarchy: "hierarchy",
    id: "id",
    inReviewConScoreThreshold: "inReviewConScoreThreshold",
    industrySector: "industrySector",
    isEqualAmounts: "isEqualAmounts",
    isFractionalUnit: "isFractionalUnit",
    key: "key",
    lastName: "lastName",
    matchedConScoreThreshold: "matchedConScoreThreshold",
    metadata: "metadata",
    name: "name",
    nameSeparator: "nameSeparator",
    newPassword: "newPassword",
    number: "number",
    oldPassword: "oldPassword",
    operationRegion: "operationRegion",
    organization: "organization",
    organizations: "organizations",
    password: "password",
    postalCode: "postalCode",
    profileEmail: "email",
    profileFirstName: "firstName",
    profileLastName: "lastName",
    profileNewPassword: "newPassword",
    profileOldPassword: "oldPassword",
    profileUsername: "username",
    reconciliationFrequency: "frequency",
    reconciliationName: "name",
    role: "role",
    rule: "rule",
    rules: "rules",
    secondAmountType: "secondAmountType",
    sourceFile: "sourceFile",
    startingBalance: "startingBalance",
    startingBalanceDate: "startingBalanceDate",
    state: "state",
    status: "status",
    streetAddress: "streetAddress",
    subscriptionPlan: "subscriptionPlan",
    timeField: "timeField",
    timeFormat: "timeFormat",
    timeZone: "timeZone",
    type: "type",
    username: "username",
    value: "value",
    windowSize: "windowSize",
} as const;
